import React, { useState } from 'react';
import api from '../services/api';

export default function Contact({ onBack }) {
  const [name,        setName]        = useState('');
  const [email,       setEmail]       = useState('');
  const [message,     setMessage]     = useState('');
  const [submitting,  setSubmitting]  = useState(false);
  const [error,       setError]       = useState('');
  const [submitted,   setSubmitted]   = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!name.trim() || !email.trim() || !message.trim()) {
      setError('Please fill in all fields.');
      return;
    }
    setError('');
    setSubmitting(true);
    try {
      await api.submitContact(name.trim(), email.trim(), message.trim());
      setSubmitted(true);
      setName('');
      setEmail('');
      setMessage('');
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="legal-page">
      <div className="legal-wrap" style={{ maxWidth: 560 }}>
        <div className="legal-header">
          <button className="legal-back" onClick={onBack}>← Back to CinemaAlert</button>
          <div className="legal-brand">🎬 Cinema Alert</div>
        </div>

        <h1 className="legal-title">Contact Us</h1>
        <p style={{ fontSize: 15, color: 'var(--text-2)', marginBottom: 32, lineHeight: 1.6 }}>
          Have a question or feedback? We'd love to hear from you.
        </p>

        {submitted ? (
          <div style={{
            background: 'rgba(22,163,74,0.12)',
            border: '1px solid rgba(22,163,74,0.3)',
            borderRadius: 'var(--r)',
            padding: '20px 24px',
            textAlign: 'center',
          }}>
            <div style={{ fontSize: 28, marginBottom: 10 }}>✅</div>
            <p style={{ fontSize: 16, fontWeight: 700, color: 'var(--text)', marginBottom: 6 }}>
              Message sent!
            </p>
            <p style={{ fontSize: 14, color: 'var(--text-2)' }}>
              Thanks! We'll get back to you soon.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} noValidate>
            {error && (
              <div className="form-error" style={{ marginBottom: 16 }}>{error}</div>
            )}

            <div className="form-group">
              <label className="form-label" htmlFor="contact-name">Name</label>
              <input
                id="contact-name"
                className="form-input"
                type="text"
                placeholder="Your name"
                value={name}
                onChange={e => setName(e.target.value)}
                disabled={submitting}
                autoComplete="name"
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="contact-email">Email</label>
              <input
                id="contact-email"
                className="form-input"
                type="email"
                placeholder="your@email.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                disabled={submitting}
                autoComplete="email"
              />
            </div>

            <div className="form-group" style={{ marginBottom: 20 }}>
              <label className="form-label" htmlFor="contact-message">Message</label>
              <textarea
                id="contact-message"
                className="form-input"
                placeholder="Your message…"
                value={message}
                onChange={e => setMessage(e.target.value)}
                disabled={submitting}
                rows={5}
                style={{ resize: 'vertical', minHeight: 110 }}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={submitting}
              style={{ width: '100%' }}
            >
              {submitting ? 'Sending…' : 'Send Message'}
            </button>
          </form>
        )}
      </div>

      <div className="legal-footer">
        <a href="/">Home</a>
        <span className="legal-footer-sep">·</span>
        <a href="/privacy-policy">Privacy Policy</a>
        <span className="legal-footer-sep">·</span>
        <a href="/terms">Terms of Service</a>
      </div>
    </div>
  );
}
